template = require('./profile_personal.html.slim')
#
angular.module('wbComponents').directive 'profilePersonal', ->
  restrict: 'E'
  templateUrl: template
  controller: ['$scope', ($scope) -> 
    $scope.otherCountryRadio = null
    $scope.$watch('ctrl.clientProfile', (value) -> 
      $scope.otherCountryRadio = false
      if $scope.ctrl && $scope.ctrl.clientProfile && $scope.ctrl.clientProfile?.otherCitizenships
        if Array.isArray($scope.ctrl.clientProfile?.otherCitizenships)
          $scope.otherCountryRadio = $scope.ctrl.clientProfile.otherCitizenships.length > 0
        else 
          $scope.otherCountryRadio = false
        if !$scope.otherCountryRadio
          $scope.ctrl.clientProfile.otherCitizenships = null
    )
    $scope.$watch('otherCountryRadio', (value) -> 
      $scope.ctrl.clientProfile.otherCitizenships = null if !value && $scope.ctrl && $scope.ctrl.clientProfile
    )
    @
  ]
  controllerAs: 'ctrl'
  bindToController: true
  replace: true
  scope:
    clientProfile: '=',
    disableTwoFactor: '&',
  link: ($scope, $el, $attrs) ->
    $scope.showSin = true if $attrs.sin is 'true'
    $scope.show2fa = !$attrs.hide2fa
